import ProtectedRoute from './ProtectedRoute.jsx'

export default ProtectedRoute